import { render, staticRenderFns } from "./signUpModal.vue?vue&type=template&id=2dd52208&scoped=true"
import script from "./signUpModal.vue?vue&type=script&lang=js"
export * from "./signUpModal.vue?vue&type=script&lang=js"
import style0 from "./signUpModal.vue?vue&type=style&index=0&id=2dd52208&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd52208",
  null
  
)

export default component.exports